interface CommentItem {
  name: string;
  avatar: string;
  time: string;
  content: string;
  likes: string;
  tag: string;
}

const comments: CommentItem[] = [
  {
    name: '综艺爱好者小陈',
    avatar: 'ri-user-smile-line',
    time: '3天前',
    content: '天天影视的画质真的太棒了！看《奔跑吧》最新一期完全不卡，高清免费真的很良心。更新速度也快，基本第二天就能看到最新内容，追综党的福音！',
    likes: '256',
    tag: '画质体验',
  },
  {
    name: '追剧达人Linda',
    avatar: 'ri-user-heart-line',
    time: '5天前',
    content: '《脱口秀大会》全集都在这里看完了，分类清晰找起来特别方便。关键是免费还能高清不缓冲，比那些收费平台体验还好，强烈推荐给喜欢看综艺的朋友们。',
    likes: '189',
    tag: '内容丰富',
  },
  {
    name: '晚间放松时刻',
    avatar: 'ri-user-star-line',
    time: '1周前',
    content: '下班回家就想看点轻松的，天天影视的搞笑综艺合集简直就是解压神器。真人秀、脱口秀、搞笑综艺分类明确，想看什么类型一目了然，已经安利给同事了。',
    likes: '312',
    tag: '解压推荐',
  },
  {
    name: '综艺老观众大刘',
    avatar: 'ri-user-3-line',
    time: '1周前',
    content: '从《中国好声音》第一季就在看综艺，天天影视的综艺库真的全。老牌综艺、新出的热门节目都有，而且更新特别及时，高清画质看音乐综艺简直是享受，五颗星推荐。',
    likes: '147',
    tag: '老粉推荐',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1100px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block bg-accent-100 text-accent-800 text-xs font-semibold px-3 py-1 rounded-full uppercase tracking-wide mb-3">
            观众热评
          </span>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-extrabold text-foreground-950 mb-3">
            综艺爱好者这样说
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-[600px] mx-auto">
            来自天天影视观众的真实反馈，听听他们怎么说
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
          {comments.map((comment, idx) => (
            <div
              key={idx}
              className="bg-background-50 rounded-xl p-5 md:p-6 border border-background-200/70 transition-all duration-300 hover:border-primary-200"
            >
              <div className="flex items-start gap-3 mb-3">
                <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center shrink-0">
                  <i className={`${comment.avatar} text-primary-600 text-lg`}></i>
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 flex-wrap">
                    <span className="font-semibold text-sm text-foreground-900">{comment.name}</span>
                    <span className="bg-secondary-100 text-secondary-700 text-xs px-2 py-0.5 rounded-full whitespace-nowrap">
                      {comment.tag}
                    </span>
                  </div>
                  <span className="text-xs text-foreground-500">{comment.time}</span>
                </div>
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed mb-3">
                {comment.content}
              </p>
              <div className="flex items-center gap-1 text-xs text-foreground-500">
                <i className="ri-thumb-up-line"></i>
                <span>{comment.likes} 人觉得有用</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}